import { TextV2 } from '@dealstack/frontend/shared/components/TextV2/TextV2';
import { StorageKeys, StorageUtilities } from '@dealstack/frontend/shared/helper/storageUtils';
import { Button as ButtonV2 } from '@dealstack/frontend/shared/components/fundament/Button/Button.v2';
import { Modal } from '@dealstack/frontend/shared/components/fundament/Modal/Modal';
import { useTranslationCommonUi } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { memo, useCallback, useEffect, useState } from 'react';
import styled from 'styled-components';

interface Props {
	className?: string;
}

const RWD_LIMIT = 1200; //(px)

const RWDErrorModal = ({ className }: Props) => {
	const tCommonUi = useTranslationCommonUi();
	const [fakeState, setFakeStaet] = useState(0);
	const shouldShowRWDModal = !StorageUtilities.getItem<boolean>(
		StorageKeys.RWD_LOCAL_STORAGE_ENTRY
	);

	const onConfirm = useCallback(() => {
		StorageUtilities.setItem(StorageKeys.RWD_LOCAL_STORAGE_ENTRY, 'true');
		setFakeStaet(2);
	}, []);
	useEffect(() => {
		window.addEventListener('resize', function () {
			if (this.window.innerWidth < RWD_LIMIT && fakeState !== 0) {
				setFakeStaet(0);
			}
			if (this.window.innerWidth > RWD_LIMIT && fakeState !== 1) {
				setFakeStaet(1);
			}
			// Do something
		});
	}, [fakeState]);
	if (window.innerWidth > RWD_LIMIT) {
		return null;
	}
	if (!shouldShowRWDModal) {
		return null;
	}

	return (
		<Modal
			onClose={onConfirm}
			size="sm"
			reactModalProps={{
				shouldCloseOnOverlayClick: false,
			}}
			closeButton={false}
			className={className}
		>
			<TextV2 variant="sans/25/600"> {tCommonUi('rwd_error.title')}</TextV2>
			<TextV2 variant="sans/14/400">{tCommonUi('rwd_error.message')}</TextV2>
			<ButtonV2
				size="s"
				variant="primary"
				buttonTheme="light"
				icon="tick"
				leftIcon
				onClick={onConfirm}
			>
				{tCommonUi('rwd_error.confirm_button')}
			</ButtonV2>
		</Modal>
	);
};

const Memoized = memo(RWDErrorModal);
const Styled = styled(Memoized)`
	${ButtonV2} {
		margin: auto;
		margin-top: 1em;
	}
`;

export { Styled as RWDErrorModal };
